/* eslint-disable */
export default {
  participants: 'Participants',
  host: '(Host)',
  removeParticipant: 'Remove participant',
  removeTitle: 'Remove participant',
  removeDescription: 'Remove {name} from this conference?',
  confirmButtonText: 'Remove',
  cancelButtonText: 'Cancel',
} as const;

// @key: @#@"participants"@#@ @source: @#@"Participants"@#@
// @key: @#@"host"@#@ @source: @#@"(Host)"@#@
// @key: @#@"removeParticipant"@#@ @source: @#@"Remove participant"@#@
// @key: @#@"removeTitle"@#@ @source: @#@"Remove participant"@#@
// @key: @#@"removeDescription"@#@ @source: @#@"Remove {name} from this conference?"@#@
// @key: @#@"confirmButtonText"@#@ @source: @#@"Remove"@#@
// @key: @#@"cancelButtonText"@#@ @source: @#@"Cancel"@#@
